var CollectionView = require('views/base/collection-view');
var PortfolioService = require('services/portfolio-service');

var ChecklistModuleView = CollectionView.extend({
  autoRender: true,
  template: require('./templates/checklist-module'),
  itemView: require('./checklist-item-view'),
  listSelector: '.checklist-items',
  noWrap: true,
  animationDuration: 0,
  getTemplateData: Chaplin.View.prototype.getTemplateData
});

module.exports = ChecklistModuleView;